import * as React from 'react'
import styled from 'styled-components'

import { Icon } from '../Icon'
import { SpecificIconProps } from '../types'
import { lightweight, standalone, SymbolProps } from '../../spritesheetUtils'

const ID = 'instagram-third-party-glyph-icon'

export function InstagramSymbol({ id = ID, ...props }: SymbolProps): React.ReactElement<SymbolProps> {
  return (
    <symbol {...props} id={id} viewBox="0 0 32 32">
      <path
        fill="current"
        fillRule="evenodd"
        d="M19.53 9c.162.024.319.06.479.067 2.231.122 3.892 1.732 3.948 3.956.058 2.34.058 4.685-.003 7.028-.059 2.186-1.714 3.844-3.904 3.902-2.35.065-4.71.06-7.065.002-1.942-.047-3.419-1.355-3.81-3.24-.081-.39-.122-.787-.175-1.184v-6.016c.023-.173.058-.343.07-.517.112-1.94 1.346-3.41 3.227-3.815.4-.089.81-.123 1.215-.183h6.018Zm-6.19 1.43c-1.846.042-2.87 1.06-2.912 2.894a149.52 149.52 0 0 0 .002 6.427c.04 1.783 1.089 2.805 2.864 2.866 1.075.037 2.155.008 3.232.008v-.007c1.105 0 2.208.03 3.309-.008.897-.028 1.698-.338 2.249-1.101.367-.515.528-1.114.531-1.732.019-2.144.042-4.287 0-6.43-.035-1.833-1.064-2.875-2.887-2.916-2.129-.048-4.26-.049-6.389 0Zm3.23 2.232a3.833 3.833 0 0 1 3.809 3.88 3.834 3.834 0 0 1-3.89 3.836 3.838 3.838 0 0 1-3.83-3.9 3.841 3.841 0 0 1 3.911-3.816Zm-.051 1.366a2.471 2.471 0 0 0-2.492 2.506 2.472 2.472 0 0 0 2.478 2.481 2.471 2.471 0 0 0 2.508-2.488 2.469 2.469 0 0 0-2.494-2.499Zm4.012-2.416c.517-.002.9.377.901.89a.904.904 0 0 1-.894.915.935.935 0 0 1-.915-.906.903.903 0 0 1 .907-.9Z"
        clipRule="evenodd"
      />
    </symbol>
  )
}

const InstagramStandaloneContent = standalone(InstagramSymbol, ID)

export const Instagram = styled(function InstagramStandaloneComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="social-instagram">
      <InstagramStandaloneContent />
    </Icon>
  )
})``

export const InstagramLightweight = styled(function InstagramComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="social-instagram">
      {lightweight(ID)}
    </Icon>
  )
})``
